/** Mirrors `WidgetConfig.printConfig.options`: env-driven keys (defaultOption, secondOption, …). */
export type RadioPrintConfig = {
  [k in mumms.ComponentName]?: Record<string, string>;
};
export type CheckOptionPrintConfig = {
  [k in mumms.ComponentName]?: Record<string, string>;
};

export const AllDates = 'All Dates';
export const DateRange = 'Date Range';
export const SingleDay = 'Single Day';

export const printOptionsConfig = {
  defaultOption: AllDates,
  secondOption: DateRange,
  thirdOption: SingleDay,
};

// Note this is left here in case we need it
export const checkboxPrintConfig: any = {
  // ClearScripts: {
  //   option: 'Signature',
  // },
};

export const Facesheet: mumms.ComponentName = 'Facesheet';
export const Manifest: mumms.ComponentName = 'Manifest';
